export const formatInteger = (value) =>
  new Intl.NumberFormat("en-MY", {
    maximumFractionDigits: 0,
  }).format(parseFloat(value));
